import { render, staticRenderFns } from "./IndexeringView.vue?vue&type=template&id=6e809350"
import script from "./IndexeringView.vue?vue&type=script&lang=js"
export * from "./IndexeringView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports